/**
 * Global cache version tag used to invalidate persisted entries when the
 * client-side data model changes. Bump this to force a cache bust.
 */
export const CACHE_VERSION = '2024-09-15T00:00Z';

export default CACHE_VERSION;
